<template>
  <div class="Box">
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="统计日期">
              <el-date-picker
                  @change="handTime"
                  style="width: 100%"
                  v-model="createdate"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说剧目">
              <SelectChecked :options="movieOptions" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择剧目"
                             @selectedVal="selectedMovie"/>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="6" class="mb20">
            <el-button size="medium" type="primary" :loading="loading" @click="addSratch">查询</el-button>
            <el-button size="medium" @click="Clear">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;"
          size="medium"
          border
          :header-cell-style="{ textAlign: 'right' }"
          :cell-style="{ textAlign: 'right' }"
          show-summary
          :summary-method="getSummaries"
          sum-text="汇总"
          v-loading="loading"
      >

        <el-table-column label="日期" align=center>
          <template slot-scope="scope">{{ scope.row.createdate }}</template>
        </el-table-column>

        <el-table-column label="激活">
          <template slot-scope="scope">{{ scope.row.new_active_num }}</template>
        </el-table-column>

        <el-table-column label="充值人数">
          <template slot-scope="scope">{{ scope.row.recharge_user }}</template>
        </el-table-column>

        <el-table-column label="充值金额">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="rechargeMoneyInfo(scope.row)">
              {{ scope.row.recharge_money }}
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
                  @pagination="getCopyRightDataList"/>

      <el-drawer
      :wrapperClosable="true"
          :title="viewTitle"
          :visible.sync="showRankings"
          size="50%"
      >
        <div class="Box">
          <el-card class="box-card">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="小说榜" name="1">
                <el-table ref="multipleTable" :data="rankingsTableData" tooltip-effect="dark" style="width: 100%"
                          size="medium"
                          :header-cell-style="{textAlign:'center',background:'#f5f7fa'}"
                          :cell-style="{textAlign:'center'}"
                          border v-loading="rankingloading">

                  <el-table-column label="排名">
                    <template slot-scope="scope">{{ scope.row.sort }}</template>
                  </el-table-column>

                  <el-table-column label="小说ID">
                    <template slot-scope="scope">{{ scope.row.id }}</template>
                  </el-table-column>

                  <el-table-column prop="name" label="小说名称">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                  </el-table-column>

                  <el-table-column prop="name" label="充值金额">
                    <template slot-scope="scope">{{ scope.row.recharge_money }}</template>
                  </el-table-column>

                </el-table>
              </el-tab-pane>

            </el-tabs>
          </el-card>
        </div>

      </el-drawer>
    </el-card>
  </div>
</template>
<script>

import {GeneralCollectApi} from '@/api/statistics/comStatistics/index';
import {movieStatisticsApi} from '@/api/statistics/movieSatistics/index';
import {processErrors} from '@/utils/errorHandler';
import SelectChecked from '@/components/Select/SelectChecked'
import {Session} from '@/utils/storage';

export default {
  name: 'GeneralCollectDetils',
  components: {
    SelectChecked
  },
  data() {
    return {
      queryParams: {//查询参数
        pageNo: 1,
        pageSize: 10,
        createdate_start: '',
        createdate_end: '',
        movie_id: '',
      },

      createdate: [],//时间区间

      tableData: [],//列表数据
      total: 0,//数据量
      totalData: [],//数据汇总

      movieOptions: [],//选择小说列表
      vipOptions: [],//选择vip列表
      optimizerOptions: [],//选择优化师列表
      referralOptions: [],//选择渠道号列表

      loading: true,//加载状态
      isRemoveAllTag: 0,//下拉框是否清空

      roleId: 1,//角色id
      isShowVip: true,//是否显示vip下拉框
      isShowOptimizer: true,//是否显示优化师下拉框

      showRankings: false,
      rankingsTableData: [],
      viewTitle: '',
      activeName: '1',
      createdateParams: '',
      rankingloading: true,
    };
  },

  created() {
    this.defaultTime();
    this.getSelectMovie();
    this.getCopyRightDataList();
  },
  methods: {

    rechargeMoneyInfo(info) {
      this.activeName = "1";
      this.showRankings = true;
      this.createdateParams = info.createdate;
      this.viewTitle = `日期：${info.createdate}  金额：${info.recharge_money}`;
      this.getMovieRanking();
    },

    handleClick(tab, event) {
      if (this.activeName == '1') {
        this.getMovieRanking();
      } else {

      }
    },

    getMovieRanking() {
      this.rankingsTableData = [];
      this.rankingloading = true;
      let api = movieStatisticsApi();
      let params = {
        createdate: this.createdateParams,
      };
      api.moviesCollectRankingAll(params)
          .then((res) => {
            if (res.code == 0) {
              this.rankingsTableData = res.data;
            } else {
              processErrors(res);
            }
            this.rankingloading = false;
          }).catch((error) => {
      });
    },

    /**
     * 生成默认时间区间(本月一号到当天)
     */
    defaultTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      // const time = '00:00:00';
      // const times = '23:59:59';
      const formattedDate = `${year}-${month}-01`;
      const formattedDates = `${year}-${month}-${day}`;
      this.createdate = [formattedDate, formattedDates];
      this.queryParams.createdate_start = formattedDate;
      this.queryParams.createdate_end = formattedDates;
    },

    /**
     * 选择小说
     */
    selectedMovie(value) {
      this.queryParams.movie_id = value.join(',');
    },

    addSratch() {
      this.getCopyRightDataList();
    },

    /**
     *选择时间
     */
    handTime(e) {
      const date = e[0];
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      // const time = '00:00:00';
      const formattedDate = `${year}-${month}-${day}`;

      const dates = e[1];
      const years = dates.getFullYear();
      const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const days = ('0' + dates.getDate()).slice(-2);
      // const times = '23:59:59';
      const formattedDates = `${years}-${months}-${days}`;

      const diffInDays = Math.floor(Math.abs((new Date(formattedDate) - new Date(formattedDates)) / (1000 * 60 * 60 * 24)));

      if (diffInDays > 90) {
        this.$message.error('检索日期最大跨度为90天');
        this.defaultTime();
      } else {
        this.createdate = [formattedDate, formattedDates];
        this.queryParams.createdate_start = formattedDate;
        this.queryParams.createdate_end = formattedDates;
      }
    },

    /**
     * 清空
     */
    Clear() {
      this.queryParams = {//查询参数
        pageNo: 1,
        pageSize: 10,
        createdate_start: '',
        createdate_end: '',
        movie_id: '',
      };
      this.isRemoveAllTag += 1;
      this.defaultTime();
    },

    /**
     * 获取选择小说列表
     */
    getSelectMovie() {
      const api = GeneralCollectApi();
      let params = {
        pageSize: 99999,
      };
      api.getSelectMovie(params)
          .then((res) => {
            if (res.code == 0) {
              let data = res.data.data;
              this.movieOptions = data.map(item => ({
                value: item.id.toString(),
                label: item.name,
                check: false
              }));
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
          });
    },

    /**
     * 获取综合统计列表
     */
    getCopyRightDataList() {
      this.loading = true;
      const api = GeneralCollectApi();
      api.copyRightDataList(this.queryParams)
          .then((res) => {
            if (res.code == 0) {
              this.tableData = res.data.data;
              this.total = res.data.totalCount;
              this.totalData = res.data.total;
            } else {
              processErrors(res);
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
    },

    /**
     * 汇总数据
     * @param param
     * @returns {*[]}
     */
    getSummaries(param) {
      const sums = [];
      sums[0] = '汇总';
      sums[1] = this.totalData.total_new_active_num;
      sums[2] = this.totalData.total_recharge_user;
      sums[3] = this.totalData.total_recharge_money;
      return sums;
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>

::v-deep .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell {
  text-align: right;
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>